import { navAnchors, siteName } from "@/mocks/media";

export default function Footer() {
  const categories = [
    { label: "焦点档案", href: "#focus" },
    { label: "攻防时间线", href: "#timeline" },
    { label: "手法拆解", href: "#tactics" },
    { label: "深度解读", href: "#reading" },
  ];
  const service = [
    { label: "公关手册", href: "#playbook" },
    { label: "常见问答", href: "#faq" },
    { label: "关于我们", href: "#about" },
    { label: "订阅选题", href: "#about" },
  ];

  return (
    <footer className="border-t border-background-300/70 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
                <i className="ri-record-circle-fill text-lg text-background-50" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                {siteName}
                <span className="ml-2 align-middle text-[10px] font-normal uppercase tracking-[0.2em] text-primary-500">
                  OBSERVER
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              关注娱乐圈舆论与危机公关的深度内容观察站，帮你在\u201c黑料\u201d与\u201c澄清\u201d之间看清套路、建立判断框架。
            </p>
            <a
              href="mailto:editorial@shenglang.example"
              rel="nofollow"
              className="mt-4 inline-flex items-center gap-2 text-sm text-primary-700 hover:underline"
            >
              <i className="ri-mail-line" />
              editorial@shenglang.example
            </a>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">快速浏览</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((c) => (
                <li key={c.label}>
                  <a href={c.href} className="text-sm text-foreground-600 hover:text-primary-700">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">服务栏目</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {service.map((c) => (
                <li key={c.label}>
                  <a href={c.href} className="text-sm text-foreground-600 hover:text-primary-700">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">内容边界</h4>
            <p className="mt-4 text-xs leading-6 text-foreground-600">
              本站为舆论与危机公关的行业观察与方法论内容，案例以中性化方式呈现，不针对真实个体作事实性断言或负面定性。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {navAnchors.slice(0, 3).map((a) => (
                <a
                  key={a.id}
                  href={`#${a.id}`}
                  className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  #{a.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-primary-950">
        <div className="mx-auto flex max-w-[1280px] flex-col gap-2 px-4 py-5 text-xs text-foreground-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <span>© {new Date().getFullYear()} {siteName} · 娱乐舆论与危机公关观察</span>
          <span className="flex items-center gap-4">
            <a href="#top" className="transition-colors hover:text-background-50">
              回到顶部
            </a>
            <span>以编辑之心，记录舆论场攻防</span>
          </span>
        </div>
      </div>
    </footer>
  );
}